import React from 'react';
import classNames from 'classnames';

import { useSelector } from 'react-redux';
import { GreenroomState, valueof } from '../../stores/types/types';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import { META_MENU_STATES } from '../../stores/types/tabs';

interface RightDrawerOptionProps {
	name: string;
	icon: valueof<typeof ICONS>;
	isActive: boolean;
	onClick: () => void;
	customSize?: number;
	unreadNotifications?: number
}

export default function RightDrawerOption({
	name,
	icon,
	isActive,
	onClick,
	customSize = 24,
	unreadNotifications = 0,
}: RightDrawerOptionProps) {
	const metaMenuState = useSelector((s: GreenroomState) => s.TabsReducer.metaMenuState);
	const metaOpen = [
		META_MENU_STATES.OPEN,
		META_MENU_STATES.OPENING,
	].includes(metaMenuState);
	const doHighlight = isActive && !metaOpen;
	return (
		<div
			className={classNames('right-drawer-option position-relative', { active: doHighlight })}
			data-testid="drawer-option-container"
		>
			<div
				className="right-drawer-button button-active-shading"
				onClick={onClick}
				data-testid="drawer-option-button"
			>
				<span className={`unseen-messages font-weight-bold notification-count-${unreadNotifications}`}>
					{unreadNotifications < 10 ? unreadNotifications : '9+'}
				</span>
				<Icon
					name={icon}
					size={customSize}
					color={doHighlight ? COLORS.WHITE : COLORS.DEFAULT_GRAY}
				/>
			</div>
			<div className="right-drawer-label font-weight-bold no-select">
				{name}
			</div>
		</div>
	);
}
